module.exports = __webpack_public_path__ + "img/bank3.c4585e7d.png";